export const fetchFileUrl = 'app/fetchFileUrl';
export const triggerHeardBeat = 'app/triggerHeardBeat';
export const stopHeartBeat = 'app/stopHeartBeat';
export const postFileUpload = 'app/postFileUpload';
